import Vue from 'vue'
import VueI18n from 'vue-i18n'
import translation from '@/translation'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'cn', // default
  fallbackLocale: 'cn',
  messages: translation
})

export default i18n
